import { baseApi } from "./baseApi";
import { retryTransientOnly } from "./retryTransientOnly";
import type { EnabledProducts, ToggleableProductKey } from "../../../shared/products";

/**
 * Per-instance product availability. The read is used by every signed-in user
 * (the product switcher and App Preferences both need it); the write is
 * skypoint_admin-only and enforced server-side by requireSkypointAdmin.
 */
export const instanceProductsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getInstanceProducts: build.query<EnabledProducts, void>({
      query: () => ({ url: "/instance/products", method: "GET" }),
      providesTags: ["InstanceProducts"],
      // The landing redirect waits on this for every user, skyEmployee on or
      // off: answer a 4xx at once, and retry a 5xx or dropped connection only
      // once, so a failure falls back to the customer portal within seconds.
      extraOptions: {
        retryCondition: (...args: Parameters<typeof retryTransientOnly>) =>
          args[2].attempt <= 1 && retryTransientOnly(...args),
      },
    }),
    updateInstanceProducts: build.mutation<
      EnabledProducts,
      Partial<Record<ToggleableProductKey, boolean>>
    >({
      query: (body) => ({ url: "/instance/products", method: "PUT", body }),
      invalidatesTags: ["InstanceProducts"],
    }),
  }),
});

export const { useGetInstanceProductsQuery, useUpdateInstanceProductsMutation } =
  instanceProductsApi;
